import { useState, useEffect } from "react";
import logo from "../../assets/img/logo.png"; // Mets ici ton chemin correct vers le logo
import floral from "../../assets/img/floral-1.png"; // Mets ici ton chemin correct vers le logo
import bgSection from "../../assets/img/bgSection.png";
import { Link, useLocation } from "react-router-dom";
import UseNavbarInteractions from "../../assets/js/UseNavbarInteractions";
import SearchBar from "./SearchBar";
import LienPanierDesktop from "../ecom_section/LienPanierDesktop";
import LienPanierMobile from "../ecom_section/LienPanierMobile";
import { ModelsDropdown } from "./ModelsDropdown";
// import DropdownFondements from "./DropdownFondements";

function LayoutPublic({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const [pages, setPages] = useState([]);
  const [scrolled, setScrolled] = useState(false);
  const [settings, setSettings] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showCloseBtn, setShowCloseBtn] = useState(false);

  const STORAGE = process.env.REACT_APP_API_BASE_URL_STORAGE;

  useEffect(() => {
    const API = process.env.REACT_APP_API_BASE_URL;

    fetch(`${API}/settings-public`)
      .then((res) => res.json())
      .then((data) => {
        const mapped = {};
        data.forEach((item) => {
          mapped[item.key] = item.value;
        });
        setSettings(mapped);

        // On vérifie ici si le popup doit être affiché
        if (mapped.popup_accueil && !sessionStorage.getItem("popupShown")) {
          setShowPopup(true);
          sessionStorage.setItem("popupShown", "true");
        }
      });

    fetch(`${API}/pages-public`)
      .then((res) => res.json())
      .then((data) => setPages(data));

    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = pages
    .filter((page) => page.template.includes("default"))
    .map((page) => ({
      label: page.title,
      to: `/${page.slug}`,
    }));

  const models = pages
    .filter((page) => page.template.includes("produit"))
    .map((page) => ({
      label: page.title,
      to: `/${page.slug}`,
    }));

  const socialIcons = [
    { key: "facebook", icon: "ri-facebook-fill" },
    { key: "twitter", icon: "ri-twitter-x-fill" },
    { key: "instagram", icon: "ri-instagram-line" },
    { key: "youtube", icon: "ri-youtube-fill" },
    { key: "tiktok", icon: "ri-tiktok-fill" },
    { key: "linkedin", icon: "ri-linkedin-fill" },
    { key: "whatsapp", icon: "ri-whatsapp-line" },
  ];

  const isBoutique = location.pathname.startsWith("/boutique");

  const isActive = location.pathname === "/prendre-rdv";

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseBtn(true);
    }, 5000); // 1000 = 1 seconde

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-[100] transition duration-300 bg-white ${
          scrolled ? " border-b border-gray-600" : ""
        }`}
      >
        <div className="w-full">
          {isBoutique ? (
            <>
              {/* ✅ 1ère ligne : petite bannière sans logo */}
              <div className="bg-green-950 py-1 px-4 text-sm text-center text-white">
                Bienvenue dans notre boutique en ligne
              </div>

              {/* ✅ 2e ligne : logo - search - actions */}
              <div className="flex justify-between items-center px-6 py-3 bg-white text-black">
                {/* Colonne 1 : Logo */}
                <Link to="/" className="shrink-0">
                  <img
                    src={settings.logo ? `${STORAGE}/${settings.logo}` : logo}
                    alt="Logo"
                    className="h-16 object-contain"
                  />
                </Link>

                {/* Colonne 2 : Barre de recherche */}
                <SearchBar />

                {/* Colonne 3 : Compte + Panier */}
                <div className="flex items-center gap-4">
                  {/* Desktop : texte */}
                  <div className="hidden lg:flex gap-4 font-semibold">
                    {/* <Link
                      to="/compte"
                      className="hover:text-green-700 flex items-center gap-1"
                    >
                      <i className="ri-user-line"></i> Mon compte
                    </Link> */}
                    <LienPanierDesktop />
                  </div>

                  {/* Mobile : icônes circulaires */}
                  <div className="flex lg:hidden gap-2">
                    {/* <Link
                      to="/compte"
                      className="text-xl bg-gray-200 p-2 rounded-full hover:text-green-700 w-10 h-10 flex items-center justify-center"
                    >
                      <i className="ri-user-line"></i>
                    </Link> */}
                    <LienPanierMobile />
                  </div>
                </div>
              </div>
            </>
          ) : (
            // ✅ Version normale du site (ton header existant)
            <div className="max-w-screen mx-auto px-6">
              {/* Desktop */}
              <div className="hidden lg:flex justify-between items-center py-2">
                <Link to="/" className="inline-block">
                  <img
                    src={settings.logo ? `${STORAGE}/${settings.logo}` : logo}
                    alt="Logo site"
                    className="w-28 h-20 object-contain"
                  />
                </Link>

                <ul className="flex gap-6 items-center">
                  {links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className={`nav-link transition duration-300 ${
                          location.pathname === link.to
                            ? "font-extrabold underline underline-offset-4 text-[#74BB43]"
                            : "font-semibold opacity-80 hover:opacity-100"
                        }`}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                  {/* Dropdown modèles */}
                  <ModelsDropdown
                    models={models}
                    currentPath={location.pathname}
                  />

                  <Link
                    to="/prendre-rdv"
                    className={`transition duration-300 px-6 py-3 rounded-lg text-sm font-semibold flex items-center gap-2 shadow-sm ${
                      isActive
                        ? "bg-green-600 text-white"
                        : "bg-orange-500 text-white hover:bg-orange-600"
                    }`}
                  >
                    <i className="ri-calendar-check-line text-lg"></i>
                    Prendre RDV
                  </Link>

                  <Link
                    to="/boutique"
                    className="transition duration-300 px-6 py-3 rounded-lg bg-gray-800 text-white text-sm font-semibold flex items-center gap-2 hover:bg-gray-700 shadow-sm"
                  >
                    <i className="ri-shopping-cart-line text-lg"></i>
                    Boutique
                  </Link>
                </ul>
              </div>

              {/* Mobile */}
              <div className="lg:hidden">
                <div className="flex justify-between items-center py-2">
                  <Link to="/" className="inline-block">
                    <img
                      src={settings.logo ? `${STORAGE}/${settings.logo}` : logo}
                      alt="logo"
                      className="w-28 h-20 object-contain"
                    />
                  </Link>
                  <div
                    className="text-3xl cursor-pointer z-50"
                    onClick={() => setMenuOpen(!menuOpen)}
                  >
                    <i
                      className={`ri-${
                        menuOpen ? "close-line" : "menu-4-line"
                      }`}
                    ></i>
                  </div>
                </div>

                <div
                  className={`absolute left-0 w-full bg-green-950/80 backdrop-blur-sm duration-300 z-40 ${
                    menuOpen ? "top-0 h-[100vh]" : "top-[-999vh]"
                  }`}
                >
                  <ul className="flex flex-col justify-center items-center gap-8 py-6 h-full">
                    {links.map((link) => (
                      <li key={link.to}>
                        <Link
                          to={link.to}
                          className={`nav-link transition duration-300 text-white ${
                            location.pathname === link.to
                              ? "font-bold underline underline-offset-4 text-[#74BB43]"
                              : "opacity-80 hover:opacity-100"
                          }`}
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                    {/* Dropdown modèles */}
                    <ModelsDropdown
                      models={models}
                      currentPath={location.pathname}
                      white
                    />
                    <Link
                      to="/prendre-rdv"
                      className={`transition duration-300 px-6 py-3 rounded-lg text-sm font-semibold flex items-center gap-2 shadow-sm ${
                        isActive
                          ? "bg-green-600 text-white"
                          : "bg-orange-500 text-white hover:bg-orange-600"
                      }`}
                    >
                      <i className="ri-calendar-check-line text-lg"></i>
                      Prendre RDV
                    </Link>

                    <Link
                      to="/boutique"
                      className="transition duration-300 px-6 py-3 rounded-lg bg-gray-800 text-white text-sm font-semibold flex items-center gap-2 hover:bg-gray-700 shadow-sm"
                    >
                      <i className="ri-shopping-cart-line text-lg"></i>
                      Boutique
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* ---------- POPUP ACCUEIL ---------- */}
      {showPopup && settings.popup_accueil && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[999]">
          <div className="bg-white rounded-lg p-4 relative max-w-lg w-full shadow-lg">
            {showCloseBtn && (
              <button
                className="absolute top-4 right-4 text-white hover:text-gray-500 bg-red-500 shadow-lg h-10 w-10 rounded-full text-lg transition duration-300"
                onClick={() => setShowPopup(false)}
              >
                ✖
              </button>
            )}
            <img
              src={`${STORAGE}/${settings.popup_accueil}`}
              alt="Popup Accueil"
              className="w-full rounded"
            />
          </div>
        </div>
      )}

      {/* -------------------------------- */}
      <div className={`min-h-screen mt-[7rem]`}>{children}</div>
      {/* -------------------------------- */}

      <footer
        className={`bg-zinc-950 text-white mt-0 pb-10
        ${location.pathname === "/" ? "pt-20 " : "pt-5"} 
        relative`}
      >
        {/* Réseaux sociaux */}
        <div className="my-10 flex justify-center space-x-4 text-2xl text-white">
          {socialIcons.map(({ key, icon }) =>
            settings[key] ? (
              <a
                key={key}
                href={settings[key]}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-orange-500 transition"
              >
                <i className={icon}></i>
              </a>
            ) : null
          )}
        </div>

        {/* Contenu principal */}
        <div className="container mx-auto px-6 py-10">
          <div className="flex flex-wrap gap-4 justify-around text-center md:text-left">
            {/* Logo */}
            <div className="w-full md:w-1/2 lg:w-[20%]">
              <img
                src={settings.logo2 ? `${STORAGE}/${settings.logo2}` : logo}
                alt="Logo footer"
                className="mx-auto md:mx-0 h-10 object-contain"
              />
            </div>

            {/* Modèles */}
            <div className="w-full sm:w-[48%] md:w-[30%] lg:w-[15%]">
              <h4 className="mb-4 font-bold text">Modèles</h4>
              <ul className="space-y-2">
                {models.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="hover:text-orange-500 transition"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Navigation */}
            <div className="w-full sm:w-[48%] md:w-[30%] lg:w-[15%]">
              <h4 className="mb-4 font-bold">Navigation</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="hover:text-orange-500 transition"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Acheter */}
            <div className="w-full sm:w-[48%] md:w-[30%] lg:w-[15%]">
              <h4 className="mb-4 font-bold">Acheter</h4>
              <ul className="space-y-2">
                {[
                  { label: "Réalisez Votre Essai", lien: "/prendre-rdv" },
                  { label: "Offre", lien: "/boutique" },
                ].map(({ label, lien }) => (
                  <li key={lien}>
                    <Link
                      to={lien}
                      className="hover:text-orange-500 transition"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="w-full sm:w-[48%] md:w-[30%] lg:w-[20%]">
              <h4 className="mb-4 font-bold">Contact</h4>
              <ul className="space-y-1 text-sm text-white/90">
                {settings.email && <li>📧 {settings.email}</li>}
                {settings.emplacement && (
                  <li>
                    {settings.emplacement.split(",").map((line, index) => (
                      <span key={index}>
                        📍 {line.trim()}
                        <br />
                      </span>
                    ))}
                  </li>
                )}

                {settings.telephone && <li>📞 {settings.telephone}</li>}
                {settings.telephone_2 && <li>☎ {settings.telephone_2}</li>}
                {settings.localisation && (
                  <li>
                    <a
                      href={settings.localisation}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-300 hover:underline"
                    >
                      📌 Voir sur la carte
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-12 text-sm opacity-60">
          {settings.mot_de_fin}
        </div>
        <div className="text-center mt-12 text-sm opacity-60">
          &copy; {new Date().getFullYear()} AsNumeric - J/E. Tous droits
          réservés.
        </div>

        {/* Décoration en bas */}
        <div className="absolute bottom-0 left-0 pointer-events-none">
          <img
            src={floral}
            alt="decor"
            width={400}
            height={200}
            className="opacity-30"
          />
        </div>
        <div className="absolute top-10 right-0 pointer-events-none">
          <img
            src={bgSection}
            alt="decor"
            width={500}
            height={400}
            className="opacity-30"
          />
        </div>
      </footer>

      {/* <!--~~~~~~~~~~~~~~~ Scroll Up ~~~~~~~~~~~~~~~--> */}
      <button
        type="button"
        className="fixed right-2 bottom-16 bg-red-500 shadow-lg px-3 py-2 md:px-4 md:py-3 rounded-md text-lg z-50 
    invisible opacity-0 translate-y-4 transition-all duration-300 ease-in-out"
        id="scroll-up"
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-white"></i>
      </button>

      <UseNavbarInteractions />
    </>
  );
}
export default LayoutPublic;
